import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import FilterService from "../../services/FilterService";
import CustomerService from "../../services/CustomerService";
import CustomerFilterService from "../../services/CustomerFilterService";
import "./EditCustomerFilter.css";

const EditCustomerFilterModal = ({ showModal, handleClose, customerFilterData = {}, onCustomerFilterUpdated }) => {
  const [formData, setFormData] = useState({
    customer_id: "",
    filter_id: "",
    date_of_installation: "",
    date_to_be_changed: "",
  });

  const [filters, setFilters] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedFilterDuration, setSelectedFilterDuration] = useState(0);

  useEffect(() => {
    const loadFiltersAndCustomers = async () => {
      try {
        const filtersResponse = await FilterService.getAll();
        const customersResponse = await CustomerService.getAll();

        setFilters(filtersResponse.data.filters || []);
        setCustomers(customersResponse.data || []);
      } catch (error) {
        console.error("Failed to load filters or customers:", error);
        toast.error("Failed to load data");
      }
    };

    loadFiltersAndCustomers();
  }, []);

  useEffect(() => {
    if (customerFilterData && Object.keys(customerFilterData).length > 0) {
      console.log("customerFilterData in Modal:", customerFilterData); 
  
      // Format dates to yyyy-MM-dd for HTML date inputs
      setFormData({
        customer_id: customerFilterData.customer_id || "",
        filter_id: customerFilterData.filter_id || "",
        date_of_installation: customerFilterData.date_of_installation ? customerFilterData.date_of_installation.split('T')[0] : "",
        date_to_be_changed: customerFilterData.date_to_be_changed ? customerFilterData.date_to_be_changed.split('T')[0] : "",
      });
  
      const selectedFilter = filters.find((f) => f.ID === customerFilterData.filter_id);
      if (selectedFilter && selectedFilter["Lasting Duration (Months)"] && !isNaN(parseInt(selectedFilter["Lasting Duration (Months)"], 10))) {
        setSelectedFilterDuration(parseInt(selectedFilter["Lasting Duration (Months)"], 10));
      }
    }
  }, [customerFilterData, filters]);
  

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "filter_id") {
      const selectedFilter = filters.find((f) => f.ID === parseInt(value, 10));
      if (selectedFilter && selectedFilter["Lasting Duration (Months)"] && !isNaN(parseInt(selectedFilter["Lasting Duration (Months)"], 10))) {
        setSelectedFilterDuration(parseInt(selectedFilter["Lasting Duration (Months)"], 10));
      }
    }

    if (name === "date_of_installation" && selectedFilterDuration > 0 && value) {
      calculateChangeDate(value, selectedFilterDuration);
    }
  };

  // Calculate the change date
  const calculateChangeDate = (installationDate, duration) => {
    if (installationDate && duration && !isNaN(duration)) {
      const date = new Date(installationDate);
      if (!isNaN(date.getTime())) {
        date.setMonth(date.getMonth() + duration);
        setFormData((prevData) => ({ ...prevData, date_to_be_changed: date.toISOString().split("T")[0] }));
      }
    }
  };

  // Update customer filter
  const updateCustomerFilter = async () => {
    try {
      if (!customerFilterData || !customerFilterData.id || Object.keys(customerFilterData).length === 0) {
        throw new Error("Invalid ID for customer filter");
      }
  
      const payload = {
        customer_id: Number(formData.customer_id) || 0,
        filter_id: Number(formData.filter_id) || 0,
        date_of_installation: formData.date_of_installation || "",
        date_to_be_changed: formData.date_to_be_changed || "",
      };
  
      console.log("Updating Customer Filter with Payload:", payload);
      await CustomerFilterService.update(customerFilterData.id || 0, payload);
  
      toast.success("Customer Filter updated successfully", { autoClose: 2000 });
      handleClose();
      onCustomerFilterUpdated();
    } catch (error) {
      console.error("Failed to update customer filter:", error.message);
      toast.error("Failed to update customer filter");
    }
  };
  

  

  return (
    <Modal 
      show={showModal && customerFilterData && Object.keys(customerFilterData).length > 0} 
      onHide={handleClose} 
      className="edit-customer-filter-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Customer Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          {/* Customer Dropdown */}
          <div className="form-group">
            <label>Customer</label>
            <select
              name="customer_id"
              value={formData.customer_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Customer</option>
              {customers.map((customer) => (
                <option key={customer.ID} value={customer.ID}>
                  {customer["First Name"]} {customer["Last Name"]}
                </option>
              ))}
            </select>
          </div>

          {/* Filter Dropdown */}
          <div className="form-group">
            <label>Filter</label>
            <select
              name="filter_id"
              value={formData.filter_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Filter</option>
              {filters.map((filter) => (
                <option key={filter.ID} value={filter.ID}>
                  {filter["Filter Name"]}
                </option>
              ))}
            </select>
          </div>

          {/* Date of Installation */}
          <div className="form-group">
            <label>Date of Installation</label>
            <input
              type="date"
              name="date_of_installation"
              value={formData.date_of_installation}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* Calculated Date to be Changed */}
          <div className="form-group">
            <label>Date to be Changed</label>
            <input
              type="date"
              name="date_to_be_changed"
              value={formData.date_to_be_changed}
              readOnly
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={updateCustomerFilter} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditCustomerFilterModal;
